export default "__VITE_ASSET__d1a81c35__"